import { Component, OnInit, OnDestroy, ViewChild, ChangeDetectionStrategy, forwardRef, ElementRef } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { MatPaginator, MatSort, MatDialog } from "@angular/material";
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

import { AddRoleDialogComponent } from './add-role-dialog.component';

import { ModuleConfiguration } from '../security.module.config';
import { TileState } from '../../pillar/dashboard/store/state/TileState';
import { StoreDataSource } from '../../core/services/StoreDataSource';
import { RoleListModel } from '../models/RoleListModel';
import { RoleModel } from '../models/RoleModel';
import * as fromStore from '../store/reducers';
import * as actions from '../../pillar/dashboard/store/actions';
import { SearchComponent } from '../../pillar/search/components/search.component';
import { DeleteRoleConfirmationDialogComponent } from './delete-role-confirmation-dialog.component';
import { TileComponent } from '../../pillar/dashboard/components/tile.component';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'brd-roles-tile',
  providers: [{ provide: TileComponent, useExisting: forwardRef(() => RolesTileComponent) }],
  templateUrl: './roles-tile.component.html',
  styleUrls: ['./roles-tile.component.scss']
})
export class RolesTileComponent extends TileComponent implements OnInit, OnDestroy {
  displayedColumns = ['name', 'type','actions'];
  dataSource: StoreDataSource<RoleListModel>;
  loading$: Observable<boolean>;
  destroyed$: Subject<boolean> = new Subject<boolean>();

  editPermission: string = 'SecurityModule.Roles:Edit';

  @ViewChild(MatPaginator)
  paginator: MatPaginator;
  @ViewChild(MatSort)
  sort: MatSort;
  @ViewChild(SearchComponent)
  search: SearchComponent;

  constructor(private store: Store<TileState<RoleListModel, RoleModel>>,
              private router: Router,
              private dialog: MatDialog,
              elementRef: ElementRef,
              private tileContainer: TileContainer) {
    super(elementRef);
    tileContainer.tileComponents.push(this);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
  }

  ngOnInit() {
    this.dataSource = new StoreDataSource<RoleListModel>(
      this.destroyed$,
      this.paginator,
      this.store,
      this.store.select(fromStore.getRoleList),
      this.store.select(fromStore.getRoleListTotalCount),
      this.store.select(fromStore.getRoleListLoading),
      (p, s, search) => new actions.QueryListAction(ModuleConfiguration.moduleName,
        RoleListModel,
        {
          page: p.pageIndex,
          pageSize: p.pageSize,
          sort: s.active,
          sortDirection: s.direction,
          searchTerm: search.searchControl.value
        }),
      this.sort,
      this.search
    );

    this.loading$ = this.store.select(fromStore.getRoleListLoading);
  }

  selectItem(item: RoleListModel) {
    this.router.navigateByUrl('role-workspace/' + item.key);
  }

  showAdd(): void {
    this.dialog.open(AddRoleDialogComponent, {
      panelClass: 'customized-dialog',
      width: '324px',
      ariaLabel: 'Add Role'
    });
  }

  delete(element: any) {
    this.dialog.open(DeleteRoleConfirmationDialogComponent,
      {
        panelClass: 'customized-dialog',
        data:
        {
          name: element.name,
          key: element.key
        }
      });
  }
}




// WEBPACK FOOTER //
// ./src/app/security/components/roles-tile.component.ts